import { render, staticRenderFns } from "./Read.vue?vue&type=template&id=7ccec9b6&scoped=true"
import script from "./Read.vue?vue&type=script&lang=js"
export * from "./Read.vue?vue&type=script&lang=js"
import style0 from "./Read.vue?vue&type=style&index=0&id=7ccec9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccec9b6",
  null
  
)

export default component.exports